import React, { useState } from 'react';

export const Cloneable = ({ 
  children, 
  qwantumId = null,
  initialClones = 1,
  onSave = () => {},
  maxClones = 10,
  addButtonText = "Add Item",
  removeButtonText = "Remove",
  style = {},
}) => {
  // State for tracking how many field sets are visible
  const [visibleCount, setVisibleCount] = useState(initialClones);
  
  // Get all children as an array
  const childrenArray = React.Children.toArray(children);
  
  // Function to reveal next field set
  const addClone = (e) => {
    // Prevent the form from submitting
    e.preventDefault();
    
    if (visibleCount < maxClones && visibleCount < childrenArray.length) {
      setVisibleCount(prev => prev + 1);
    }
  };
  
  // Function to hide and clear a field set
  const removeClone = (e, index) => {
    // Prevent the form from submitting
    e.preventDefault();
    
    // Find all form elements in this field set and clear their values
    const fieldSet = document.getElementById(`clone-${index}`);
    if (fieldSet) {
      const inputs = fieldSet.querySelectorAll('input, textarea');
      inputs.forEach(input => {
        input.value = '';
        // Trigger change event to ensure the form knows about the change
        const event = new Event('change', { bubbles: true });
        input.dispatchEvent(event);
      });
    }
    
    // If this is the last visible clone, reduce the count
    if (index === visibleCount - 1) {
      setVisibleCount(prev => prev - 1);
    }
  };
  
  return (
    <div style={{ width: '100%', ...style }}>
      {/* Only render the visible children */}
      {childrenArray.slice(0, visibleCount).map((child, index) => (
        <div 
          id={`clone-${index}`}
          key={`clone-${index}`} 
          style={{ 
            display: 'flex', 
            alignItems: 'flex-start',
            marginBottom: '16px',
            border: '1px solid #eee',
            padding: '16px',
            borderRadius: '4px',
            position: 'relative',
          }}
        >
          <div style={{ flex: 1 }}>
            {child}
          </div>
          <button
            type="button" // Explicitly set type to button
            className="delete"
            onClick={(e) => removeClone(e, index)}
            style={{
              position: 'absolute',
              top: '8px',
              right: '8px',
            }}
            aria-label="delete"
          ></button>
        </div>
      ))}

      {/* Add button - only show if we haven't reached max visible */}
      {visibleCount < Math.min(maxClones, childrenArray.length) && (
        <button
          type="button" // Explicitly set type to button
          className="button is-primary is-light"
          onClick={addClone}
          style={{
            marginTop: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span className="icon is-small">
            <i className="fas fa-plus"></i>
          </span>
          <span>{addButtonText}</span>
        </button>
      )}
    </div>
  );
};

export default Cloneable;